import styled from 'styled-components'
import COLORS from '@colors'

export const Container = styled.div`
  max-width: 100%;
  position: relative;
`

export const OptionLabel = styled.span`
  color: ${COLORS.gray28};
  line-height: 24px;
  font-weight: 800;
`

export const Button = styled.button`
  align-items: center;
  font-weight: bold;
  text-align: left;
  background-color: ${COLORS.whiteF3};
  border: 0;
  border-radius: 4px;
  color: ${COLORS.gray45};
  display: flex;
  font-family: 'Barlow';
  height: 32px;
  padding: 10px 10px;
  width: 100%;
  cursor: pointer;
  outline: 0;
`

export const InputLabel = styled.label`
  display: block;
  font-size: 10px;
  line-height: 10px;
  padding-bottom: 9px;
  text-align: left;
  width: 100%;
`

export const Label = styled.div`
  line-height: 14px;
  max-height: 14px;
  max-width: calc(100% - 9px);
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 9px);
`

export const Popover = styled.div`
  background-color: ${COLORS.white};
  border-radius: 4px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  max-height: 200px;
  max-width: 100%;
  overflow: auto;
  padding-top: 10px;
  padding-left: 24px;
  padding-right: 24px;
  position: absolute;
  top: 42px;
  z-index: 3;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${COLORS.whiteF3};
    border-radius 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.whiteD};
    border-radius: 4px;
  }

  .row {
    margin-bottom: 8px;
  }
`
